import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { General, Widget } from "../../../Constant";
import CurrencyWidget from "./CurrencyWidget";
import RadialProgress from "./RadialProgress";
import SalesReport from "./SalesReport";
import CourseBox from "./CourseBox";
import TotalUserAndFollower from "./TotalUserAndFollower";
import VisitorsCard from "./VisitorsCard";
import SocialWidgets from "./SocialWidgets";
import SmallWidgets from "./SmallWidgets";
import YourBalanceCard from "./YourBalanceCard";
import CalenderCard from "./CalenderCard";

const DefaultWidgetContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={General} parent={Widget} title={General} />
      <Container fluid>
        <Row>
          <CurrencyWidget />
          <RadialProgress/>
          <SalesReport/>
          <CourseBox/>
          <TotalUserAndFollower/>
          <VisitorsCard/>
          <SocialWidgets/>
          <SmallWidgets/>
          <YourBalanceCard/>
          <CalenderCard/>
        </Row>
      </Container>
    </>
  );
};

export default DefaultWidgetContainer;
